
	import { mapGetters } from "vuex";
	import InputCurrency from './InputCurrency.vue';

	export default {
		components: {InputCurrency},
		data: function () {
			return {
				quantity: 1,
				maxMessageLength: 200,
				delivery_type:
					this.product.FulfilmentMethods.length == 1
						? this.product.FulfilmentMethods[0].id
						: false,
				price_modifier: this.product.PriceModifiers.length > 0 ? this.product.PriceModifiers[0].id : null,
				modalBasket: [],
				message: "",
				messageLimited: {
					value: "",
					charPerLine: 45,
					lineLimit: 10,
				},
				custom_price_modifier_value: null,
				isInputActive: false,
				event_location: this.product.TicketProductConfig ? this.product.TicketProductConfig.Units[0].id : null,
				event_time_id: null,
				showCustomMessageInput: false,
				selectedDeliveryOption: 'Digital',
			};
		},
		computed: {

			...mapGetters({
                 productStock: "getProductStock",
             }),
			// fulfilment methods without pay it forward

			displayFulfilmentMethods() {
				return this.product.FulfilmentMethods.filter(
					(fm) => ![6, 7, 10].includes(fm.id)
				).map(method => {
          const productHasSMS = this.product.FulfilmentMethods.find(fm => fm.id == 10)
          return method.id == 1 && productHasSMS ? {...method, name: 'Digital'} : method
        });
			},

			// for giftcards / expiriences if there is only one fulfilment method, we want to display it to the user
			displaySingleFulfilmentMethod() {
				return this.displayFulfilmentMethods.length === 1 && [1, 2].includes(this.type);
			},

			// format the price modifier display value
			getPriceModifierLabel() {
				return (modifier) => {
					if ([2, 3, 4, 5].includes(this.type)) {
						const description = modifier.description ? `${modifier.description} - ` : '';
						return description + this.getPriceModifierDisplayValue(modifier, 1);
					} else {
						return this.getPriceModifierDisplayValue(modifier, 1);
					}
				};
			},

			/**
			 * Checks if the message should have forced linebreak and line limit, uses @type {object} messageLimited instead of @type {string} message
			 */
			isLimitedMessage() {
				// Toggle Fulfilment === TRUE
				// Fulfilment methods includes Postal
				return this.product.FulfilmentMethods.filter((fm) => [2].includes(fm.id))
					.length > 0 && this.$store.getters.getAccount.toggle_fulfilment === true
					? true
					: false;
			},

			// If toggle fulfilment is false, and one of the fulfilment methods is 'postal', use the custom settings for characters and lines
			isCustomLengthMessage() {
				// Toggle Fulfilment === FALSE
				// Fulfilment methods includes Postal
				return this.product.FulfilmentMethods.filter((fm) => [2].includes(fm.id))
					.length > 0 &&
					this.$store.getters.getAccount.toggle_fulfilment === false
					? true
					: false;
			},

			type() {
				return this.product.ProductType.id ? this.product.ProductType.id : false;
			},

			isTicket() {
				return this.product.ProductType.id && this.product.ProductType.id == 5
			},

			shouldShowCustomInput() {
        return this.product.allow_custom_price_modifier && (this.product.webshop_min_custom_value && this.product.webshop_max_custom_value);
      },

      shouldShowPriceModifiers() {
        return this.product.PriceModifiers.length > 0 ? true : false;
      },

      shouldShowCustomInputOnly() {
        return (this.product.allow_custom_price_modifier && this.product.webshop_min_custom_value && this.product.webshop_max_custom_value) && this.product.PriceModifiers.length == 0;
      },

			/**
			 * Facilitates the product message counter and splicing the message length to the max allowed
			 */
			messageLength() {
				if (this.message.length > this.maxMessageLength)
					this.message = this.message.substring(0, this.maxMessageLength);
				return (
					"<small>" + this.message.length + "</small> / " + this.maxMessageLength
				);
			},

			/**
			 * Shows current character counter and max for the messageLimited
			 */
			messageLimitedLength() {
				return (
					"<small>" +
					this.msgLimitedChars +
					"</small> / " +
					this.messageLimitMaxChars
				);
			},

			/**
			 * Get current typed characters from messageLimited, removes linebreaks from counter.
			 */
			msgLimitedChars() {
				return this.messageLimited.value.replace(/(\r\n|\n|\r)/gm, "").length;
			},

			messageLimitMaxChars() {
				return this.messageLimited.lineLimit * this.messageLimited.charPerLine;
			},

			productQuantity: {
				get: function () {
					return this.quantity;
				},
				set: function (modifiedValue) {
					if (modifiedValue > 999) modifiedValue = 999;

					if (modifiedValue < 0) modifiedValue = 1;

					this.quantity = modifiedValue;
				},
			},

			// should the personalised message field display?
			personalMessageActive() {
				// Show message if allow_personal_message has been set on this product (supersedes previous global setting this.$store.getters.getAccount.custom_message_for_postal_products_active)
				if (this.product.allow_personal_message) {
					this.setMessageCharsAndLines();
					return true;
				}

				// if it's set to not display for postal cards, and email cards isn't selected, don't show it and remove any message
				if (!this.product.allow_personal_message && this.delivery_type != 1) { // 1 is email
					this.message = "";
					return false;
				}

				return true;
			},

			isMobile() {
				return this.$store.getters.getIsMobile;
			},

			modalWidth() {
				return this.isMobile ? "100%" : 550;
			},

			/**
			 * Get correct currency symbol for this account
			 */
			accountCurrency() {
				let account = this.$store.getters["getAccount"];

				return {
					symbol: account.Currency.symbol,
					denomination: account.Currency.denomination
				}
			},

      deliveryText() {
        const postOnly = this.displayFulfilmentMethods[0].id === 2
        const digitalNotEmail = this.displayFulfilmentMethods[0].name == 'Digital'
        const text = postOnly ? 'via post' : (digitalNotEmail ? 'digitally' : `via ${this.displayFulfilmentMethods[0].name?.toLowerCase()}`)
        return `Your ${ this.product.ProductType.name } will be delivered ${text}.`
      },

      allEventTimesPast() {
        const arr = this.eventTimes || [];
        if (!Array.isArray(arr) || arr.length === 0) return false;
        return arr.every(e => e && e.is_past === true);
      }

    },
		props: ["product", "editProduct", "soldOut", "showSchedulingFlag", "eventTimes"],
    created() {
      if (this.product.TicketProductConfig && Array.isArray(this.eventTimes) && this.eventTimes.length > 0) {
        const firstFuture = this.eventTimes.find(et => et && et.is_past === false);
        if (firstFuture) this.event_time_id = firstFuture.id;
      }
    },
		mounted: function () {
			// if this is editing an existing card rather than buying a new one, populate the models with the existins details
			if (this.editProduct) {
				this.quantity = this.editProduct.quantity;
				this.delivery_type = this.editProduct.delivery_type;
				this.price_modifier = this.editProduct.custom_price_modifier_value ? 'Custom' : this.editProduct.price_modifier.id;
				this.custom_price_modifier_value = this.editProduct.custom_price_modifier_value ?? null;
				this.message = this.editProduct.message;
				this.messageLimited.value = this.editProduct.message;

				if (this.isTicket) {
					this.event_time_id = this.editProduct.event_slot_id;
					this.event_location = this.editProduct.unit_id;
				}
			}else{
				//auto select a delivery option if there are fulfillment methods available
				if (this.displayFulfilmentMethods.length > 0) {
					this.selectDeliveryOption(this.displayFulfilmentMethods[0].id);
				}
			}

			if (this.product.ProductType.id == 3) { //pay it forward
				this.delivery_type = 6; //pay it forward
			}


		},
		watch: {
			/**
			 * If the basket item has been edited and changed from custom to fixed amount, reset custom settings
			 * @return void
			 */
			price_modifier(newValue) {
				if (newValue !== "Custom") {
					this.custom_price_modifier_value = null;
				}
			},
			 // whenever quantity changes, this function will run
			productQuantity(newQuantity) {
				this.quantity = Math.floor(this.quantity);
			},
		},
		methods: {
			/**
			 * Change the quantity model for this product
			 * @type {integer} incremenet of direction (-1,1)
			 * @return void
			 */
			changeQuantity(increment) {

				let stock_remaining = 0;

				if (this.isTicket) {
					stock_remaining = this.productStock(this.product, true, this.event_location, this.event_time_id).stock_remaining;
				} else {
					stock_remaining = this.productStock(this.product).stock_remaining;
				}

				this.quantity = Number(this.quantity) + increment;

				// Don't allow quantity to be less than 1 or greater than 50
				if (this.quantity <= 0) this.quantity = 1;
				if (this.quantity > 50) this.quantity = 50;


				if (stock_remaining !== null) {

					// if editing the product after adding to the basket, we can allow the stock remaining + the edited product quantity)
					if (this.editProduct && this.quantity > stock_remaining + this.editProduct.quantity) {

						this.quantity = stock_remaining + this.editProduct.quantity;

					// else if NOT editing ie. new addition, and quantity is greater than stock remaining, set quantity to equal stock remaining
					} else if (!this.editProduct && this.quantity > stock_remaining) {

						this.quantity = stock_remaining;

					}
				}
			},

			getProductConfiguration() {
				let config = {
					id: this.product.id,
					name: this.product.name,
					price_modifier: this.price_modifier === "Custom" ? null : this.price_modifier,
					custom_price_modifier_value: this.custom_price_modifier_value,
					quantity: this.quantity,
					message: (this.isCustomLengthMessage || this.isLimitedMessage) ? this.messageLimited.value : this.message,
					delivery_type: this.delivery_type,
          show_mobile_delivery: this.allowMobileDelivery(this.product, this.delivery_type),
					allow_scheduling: this.product.allow_scheduling,
					hard_expiry_at: this.product.CurrentExpiryConfig ? this.product.CurrentExpiryConfig.hard_expire_at : null,
					quantity_config: this.createQuantityConfig(
						this.delivery_type,
						this.quantity
					),
				}

				if (this.event_location) {
					config.event_location = this.event_location
				}

				if (this.event_time_id) {
					let event_slot = this.product.TicketProductConfig.EventSlots.filter(slot => {
						return slot.id == this.event_time_id
					})

					config.event_time = event_slot[0];
					config.event_slot_id = this.event_time_id;
				}

				return config;
			},

			createQuantityConfig(delivery_type, quantity) {
				var toReturn = [];
				var iteration = 0;

				while (iteration < quantity) {
					iteration++;

					var config = {
						name: "",
						first_name: "",
						last_name: "",
						address_line_1: "",
						address_line_2: "",
						town_city: "",
						postcode: "",
						post_type: false,
						email: "",
            phone_number: "",
						email_type: false,
            schedule_selected: this.product.allow_scheduling ? 'now' : null,
            scheduled_date: null,
            scheduled_time: null,
					};

					toReturn.push(config);
				}

				return toReturn;
			},

			addProductToBasket() {
				var product = this.getProductConfiguration();
				var modalProduct = {
					quantity: product.quantity,
					name: product.name,
				};

				this.modalBasket.push(modalProduct);
				this.$store.commit("basket/PUSH_TO_BASKET", product);
				this.show("add_to_basket");
			},

			validateForm(callback, callback_args) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						callback(callback_args);
					} else {
						this.scrollToError();
					}
					return false;
				});
			},

			addToBasketContinueShopping() {
				if (!this.validateForm(this.addToBasketCallback, false)) return;
			},

			addToBasketCheckout() {
				if (!this.validateForm(this.addToBasketCallback, true)) return;
			},

			/**
			 * add product to basket and navigate to next page
			 * @type {boolean} true for go straight to checkout, false for conitnue shopping
			 * @return void
			 */

			addToBasketCallback(checkout) {
				this.addProductToBasket();
				if (checkout) this.navigateToBasket();
			},

			navigateToBasket() {
				this.modalBasket = [];
				this.$router.push({ name: "basket" });
			},

			saveItem() {
				if (!this.validateForm(this.saveItemCallback)) return;
			},

			saveItemCallback() {
				var product = this.getProductConfiguration();
				var index = this.editProduct.index;
				this.$store.commit("basket/UPDATE_BASKET_INDEX", {
					index: index,
					value: product,
				});
        this.$store.commit('basket/RESET_GROUPED_FULFILMENT_CONFIG', false);
			},

			handleHideBasketModal() {
        this.hide("add_to_basket");
      },

			/**
			 * show or hide a modal
			 */
			show(modal) {
				this.$modal.show(modal);
			},
			hide(modal) {
				this.modalBasket = [];
				this.$modal.hide(modal);
			},

			/**
			 * Limit number of characters per line in personalized message
			 * @param {event} event from keyup on textarea
			 * @return void
			 */
			limitPersonalMessage(event) {
				this.errors.clear(); //Clears the errors if keyup on input
				let val = event.target.value; //Get current value of input
				let charPerLine = this.messageLimited.charPerLine; // Get max character per line from data
				let lineLimit = this.messageLimited.lineLimit; // Get max line numbers from data
				let lines = val.split("\n"); // Transforms the  current value into an array for each line

				// Forces a linebreak if the max number of characters is reachead and deals with spacing on linebreak
				for (let i = 0; i < lines.length; i++) {
					if (lines[i].length <= charPerLine) continue;
					let j = 0;
					let space = charPerLine;
					while (j++ <= charPerLine) {
						if (lines[i].charAt(j) === " ") space = j;
					}
					lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
					lines[i] = lines[i].substring(0, space);
				}

				/**
				 * if current number of lines is less or equal the max number of lines then create a new line
				 * else add an error and don't let the user type more than that
				 */
				if (lines.length <= lineLimit) {
					this.messageLimited.value = lines.slice(0, lineLimit).join("\n");
				} else {
					this.errors.add({
						field: "message_limited",
						msg: "Maximum number of lines reached",
					});
					this.messageLimited.value = this.messageLimited.value.slice(0, -1);
				}
			},

			// If personal messages are allowed, set the number of characters per line and number of lines based on api fields
			// and calculate the total number of characters based on these two fields
			setMessageCharsAndLines() {
				if (!this.product.allow_personal_message) return;

				let { num_message_chars_per_line, num_message_lines } = this.product;

				this.messageLimited.charPerLine = num_message_chars_per_line;
				this.messageLimited.lineLimit = num_message_lines;
				this.maxMessageLength = num_message_chars_per_line * num_message_lines;
			},

			/**
			 * Gets the display text for the tickets remaining per time slot
			 * Shows SOLD OUT for sold out tickets, and either just the time name eg. 12:30pm, or the time name plus number remaining
			 * @param {object} product
			 * @param {object} time the event slot
			 * @param {integer} event_location the unit id
			 */
			displayTicketsRemainingPerSlot(product, time, event_location) {

				if (product.sale_limit) {

          if(this.ticketSoldOut(product, time, event_location)){
            return `${time.name} - SOLD OUT`;
          }

					// If display_text is null (cache still loading), just show the time
					if (!this.productStock(product, true, event_location, time.id).display_text) {
						return time.name
					}

					// If it should show number remaining
					if (this.productStock(product, true, event_location, time.id).show_stock_remaining) {
						return `${time.name + ' (' + this.productStock(product, true, event_location, time.id).display_text + ')'}`
					}

					// Otherwise just show the time
					return time.name

				} else {

          if(time.is_past){
            return `${time.name} - NO LONGER AVAILABLE`;
          }

					return time.name
				}
			},

			ticketSoldOut(product, time, event_location) {
				return this.productStock(product, true, event_location, time.id).sold_out;
			},

			toggleCustomMessageInput() {
				this.showCustomMessageInput = !this.showCustomMessageInput;
				if(!this.showCustomMessageInput) {
					this.message = "";
					this.messageLimited.value = "";
				}
			},
			/**
			 * Set the selected delivery option
			 * @param {string} option - The delivery option ('Postal' or 'Digital')
			 */
			selectDeliveryOption(option) {
				this.delivery_type = option;
			}
    },
	};
